var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.804-102.804v-77.544h754.631v77.544H102.804Zm74.153-215.957L63.804-510.826l59.066-10.718 70 62 216.5-57.565-171.761-289.043 73.304-21.957 287.044 259.044 217.608-58.805q30.957-8 56.413 12.12 25.457 20.12 25.457 52.598 0 23.195-13.478 40.793-13.479 17.598-34.196 21.598l-672.804 182Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.d914df52b91ef6d43955224dcf44cff9.svg";
export { ForwardRef as ReactComponent };